export const abitAccountMapper = (data) => {
    return {
        id: data.id,
        nickname: data.nickname,
        username: data.username,
        password: data.password,
        wsPassword: data.wsPassword,
        wsUsername: data.wsUsername,
        abitRefs: Array.isArray(data.abitRefs) ? data.abitRefs.map(r => abitRefMapper(r)) : [],
    }
}

export const abitRefMapper = (data) => {
    return {
        id: data.id,
        ref: data.ref,
        totalRooms: data.totalRooms,
        totalBeds: data.totalBeds,
        accommodationUnitIds: Array.isArray(data.accommodationUnitIds) ? data.accommodationUnitIds : [],
    }
}